module.exports = __webpack_public_path__ + "media/images/vehicles/fbp-8c77bf973792a33c5d50671e1bc44fcb.png";